import { render, staticRenderFns } from "./WaterSwitchView.vue?vue&type=template&id=b30af61e&scoped=true&"
import script from "./WaterSwitchView.vue?vue&type=script&lang=js&"
export * from "./WaterSwitchView.vue?vue&type=script&lang=js&"
import style0 from "./WaterSwitchView.vue?vue&type=style&index=0&id=b30af61e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30af61e",
  null
  
)

export default component.exports